'use client';

import { projectApi } from '@highlight-cp/project-api';

import { useGetCurrentUser } from '../use-get-current-user';

interface UseOrgCommunitySlugOptions {
  skip?: boolean;
}

/**
 * The current org's community slug, or null when it has none.
 * An org has at most one community today, matching the read in feature-guided-setup.
 */
export const useOrgCommunitySlug = ({ skip = false }: UseOrgCommunitySlugOptions = {}) => {
  const { data: currentUser } = useGetCurrentUser();
  const orgId = currentUser?.organization?.id;

  const { data: communities } = projectApi.useGetOrganizationsByOrgIdCommunitiesQuery(
    { orgId: orgId ?? 0 },
    { skip: skip || !orgId },
  );

  return communities?.[0]?.slug ?? null;
};
